import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

/* import { TabsList, TabsItem } from 'bricks/Tabs';
import InlineSet from 'bricks/InlineSet';
import { TextInput } from 'components'; */
import { Dropdown } from '@beef/ui-kit';

import { setActiveSortButton } from 'store/ProductDetails/delivery/actions';
import { getDeliverySortActiveButton } from 'store/ProductDetails/delivery/selectors';
import { isScreenBelow1004 } from 'store/common/settings/breakpoint/selectors';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

function kitSlugToSlug(slug) {
  if (slug === '0') {
    return 'address';
  } else if (slug === '1') {
    return 'metro';
  }
  return 'address';
}

function slugToKitSlug(slug) {
  if (slug === 'address') {
    return '0';
  } else if (slug === 'metro') {
    return '1';
  }
  return '0';
}

function TakeAwayDropDown({ changeActiveSortButton, sortBy, isTablet }) {
  return (
    <div className={cx('wrap')}>
      <Dropdown
        onChange={(slug) => changeActiveSortButton(kitSlugToSlug(slug.toString()), true, false)}
        options={[
          { label: 'По адресу А–Я', slug: '0' },
          { label: 'По метро А–Я', slug: '1' },
        ]}
        value={slugToKitSlug(sortBy.toString())}
        className={cx(isTablet ? 'selectMobile' : '', 'dropdown')}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  sortBy: getDeliverySortActiveButton(state),
  isTablet: isScreenBelow1004(state),
});

TakeAwayDropDown.propTypes = {
  changeActiveSortButton: PropTypes.func,
  sortBy: PropTypes.func,
  isTablet: PropTypes.bool,
};

const mapDispatchToProps = {
  changeActiveSortButton: setActiveSortButton,
};

export default connect(mapStateToProps, mapDispatchToProps)(TakeAwayDropDown);
